app.filter('boolean', [
    function() {
        return function(input) {
            return (input ? 'T.UI.APPLICATION.YES' : 'T.UI.APPLICATION.NO');
        };
    }
]);